import { useQuery } from '@tanstack/react-query'
import { authApi } from './auth-api'
import { authQueryKeys } from './query-keys'

export function useMeQuery() {
  return useQuery({
    queryKey: authQueryKeys.me(),
    queryFn: () => authApi.getMe(),
    staleTime: Infinity,
    retry: false,
  })
}
